import * as React from 'react';
import HelpInputSearch from "@/components/help/HelpInputSearch";
import { Box, Container, Grid, Typography, Skeleton, Button, Drawer, List, ListItem, useTheme, useMediaQuery } from "@mui/material";
import CategoryList from "@/components/help/CategoryList";
import FAQList from "@/components/help/FAQList";
import * as ApiHelp from "@/api/help";
import { GetServerSideProps } from "next";
import { ApiResponseForArticleList, ContentIArticleList, IHelpCategoryData, IHelpForRecommend } from "@/interfaces/help";
import { useRouter } from "next/router";
import MenuCategoryList from "@/components/help/MenuCategoryList";
import ContentArticleList from "@/components/help/ContentArticleList";
import MenuIcon from '@mui/icons-material/Menu';
import Request from '../../../components/help/request'
import { useState } from 'react';

interface Props {
    categories: IHelpCategoryData[];
    recommendations: IHelpForRecommend[];
}

const HelpCenterPage = ({ categories, recommendations }: Props) => {
   
    const router = useRouter();
    const { slug } = router.query;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [loading, setLoading] = React.useState(false);
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const [dataListArticleFaq, setDataListArticleFaq] = React.useState<ContentIArticleList[]>([]);
   
    const fetchListArticleFaq = async (slugValue: string) => {
        try {
            setLoading(true);
            const listArticleFaqResponse: ApiResponseForArticleList = await ApiHelp.GetHelpListArticleFaq(slugValue);

            if (listArticleFaqResponse.success) {
                setDataListArticleFaq(listArticleFaqResponse.data);
            } else {
                setDataListArticleFaq([])
                console.error("Error fetching articles", listArticleFaqResponse.error);
            }
        } catch (error) {
            console.error("Error in fetchListArticleFaq:", error);
        } finally {
            setLoading(false);
        }
    };

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }
        setDrawerOpen(open);
    };


    React.useEffect(() => {
        if (slug && Array.isArray(slug)) {
            const slugValue = slug[1] ?? slug[1] ?? slug[0];
            fetchListArticleFaq(slugValue);
        }
    }, [slug]);

    return (
        <>
            <HelpInputSearch form={"SHOP"} faqs={recommendations}/>
            <Box>
                <>
                    {!slug ? (
                       <>
                            <Container maxWidth="lg">
                                <CategoryList categories={categories} loading={loading} linkMain={"/help/shop/"} />
                                <FAQList faqs={recommendations} loading={loading} linkMain={"/help/shop/"} />
                            </Container>
                            <Request />
                       </>
                    ) : (
                        <Container maxWidth="lg" sx={{ mt: 5 }}>
                            <Grid container spacing={2}>
                                {isMobile ? (
                                    <Grid item xs={12}>
                                        <Button onClick={toggleDrawer(true)} sx={{ mx: 1, p: 0, minWidth: 'auto', display: 'inline-block' }}>
                                            <MenuIcon sx={{ width: '30px', height: '30px', m: 0, p: 0, color: '#000000', fontSize: 30 }} />
                                        </Button>
                                        <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                                            <Box
                                                role="presentation"
                                                onKeyDown={toggleDrawer(false)}
                                            >
                                                    <MenuCategoryList categories={categories} setDrawerOpen={setDrawerOpen}  />
                                            </Box>
                                        </Drawer>
                                    </Grid>
                                ) : (
                                    <Grid item xs={12} md={4}>
                                                <MenuCategoryList categories={categories}  />
                                    </Grid>
                                )}
                                <Grid item xs={12} md={8}>
                                    <ContentArticleList articles={dataListArticleFaq} loading={loading} />
                                </Grid>
                                    
                            </Grid>
                        </Container>
                    )}
                </>
            </Box>
        </>
    );
};

export default HelpCenterPage;

export const getServerSideProps: GetServerSideProps<Props> = async (context) => {
    try {
        const categoryResponse = await ApiHelp.GetHelpListCategory();
        const recommendResponse = await ApiHelp.GetHelpRecommend();

        if (categoryResponse.success && recommendResponse.success) {
            return {
                props: {
                    categories: categoryResponse.data || [],
                    recommendations: recommendResponse.data || [],
                },
            };
        }

        return {
            props: {
                categories: [],
                recommendations: [],
            },
        };
    } catch (error) {
        console.error("Error fetching data:", error);
        return {
            props: {
                categories: [],
                recommendations: [],
            },
        };
    }
};
